/**
 * Resolves the RouteOne finance-company id to send on credit-decision submit.
 *
 * `dealSourceLender` is the lender that decisioned the deal (credit-decision GET).
 * Dealer SSO users then pick a different lender on the LR page (e.g. Ally Prime),
 * so submit must use that lender's configured `route_one_id` instead (SWA-8014).
 */
export const getSubmitRouteOneLenderId = (
  selectedLenderRouteOneId?: string | null,
  dealSourceLender?: string | null,
): string | undefined => {
  const selected = selectedLenderRouteOneId?.trim();

  if (selected) return selected;

  const fromDeal = dealSourceLender?.trim();

  return fromDeal || undefined;
};
